const emptyArray = Object.freeze([]);
export {
  emptyArray
};
//# sourceMappingURL=emptyArray.js.map
